<template>
  <div class="scheme-investment-estimate">
    <SimpleTable
      ref="schemeInvestmentEstimate"
      table-code="schemeInvestmentEstimate"
      :menus="['查询', '批量修改', '插入', '批量删除']"
      :rightFrozenColCount="1"
      :leftFrozenColCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />
    <DesignDetail ref="designDetailRef" @close="getTable" />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, getOptions, addCbFn } from '@/utils/index'
import DesignDetail from './DesignDetail.vue'

export default {
  name: 'SchemeInvestmentEstimate',
  components: {
    SimpleTable,
    DesignDetail
  },
  data() {
    return {
      // 页面数据
      columns: [
        {
          field: 'name',
          title: '估算名称',
          canEdit: true,
          canModify: true
        },
        // {
        //   field: 'moreDesignOptionsName',
        //   title: '立项方案',
        //   canModify: true,
        //   ...getOptions(
        //     {
        //       title: '立项方案',
        //       key: 'moreDesignOptionsName',
        //       options: () => this.getSchemeOptions(),
        //       confirm: (selectedCellInfos, res) => {
        //         const row = res[0][0].originData
        //         selectedCellInfos.forEach(cells => {
        //           const obj = cells[0].originData
        //           this.$set(obj, 'moreDesignOptionsName', row.name)
        //           this.$set(obj, 'moreDesignOptionsId', row.id)
        //         })
        //       }
        //     },
        //     false
        //   )
        // },
        {
          field: 'projectName',
          title: '项目名称',
          editModal: {
            columns: [
              { field: 'name', title: '项目名称' },
              { field: 'regionName', title: '所在地区' }
            ],
            options: async () => {
              const res = await this.$service.get('/project/list')
              return res?.data || []
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'projectName', row.name)
                this.$set(obj, 'projectId', row.id)
              })
            }
          },
          canModify: true
        },
        {
          field: 'regionName',
          title: '所在区域',
          editModal: {
            columns: [{ field: 'name', title: '所在地区' }],
            options: async () => {
              const res = await this.$service.get('/region/list', {})
              return sortRecords(res?.data || [])
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'regionName', row.name)
                this.$set(obj, 'regionId', row.id)
              })
            }
          },
          canModify: true
        },
        { field: 'address', title: '详细地址', canEdit: true, canModify: true },
        {
          field: 'measurementUnit',
          title: '计量单位',
          canEdit: true,
          canModify: true
        },
        {
          field: 'constructionScale',
          title: '建筑规模',
          canEdit: true,
          canModify: true
        },
        { field: 'estimateAmount', title: '估算金额' },
        { field: 'costIndicator', title: '造价指标' },
        { field: 'breakEvenPoint', title: '盈亏平衡点' },
        { field: 'profitCycle', title: '盈利周期' },
        {
          field: 'operation',
          title: '操作',
          width: 80,
          cellType: 'text',
          buttons: [
            {
              action: 'openModal',
              text: '投资估算',
              click: (row, record) => this.openModal(row, record),
              style: { backgroundColor: '#ff4d4f', color: '#ffffff' }
            }
          ]
        }
      ],
      tableData: [{ id: 1 }],
      loading: false
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getTable()
    },
    async getTable() {
      this.tableData = []
      this.loading = true
      const res = await this.$service.get(
        '/plan-investment-estimate/list',
        {}
      )
      this.loading = false
      res.data.forEach(e => {
        e.resultPictureFileUrl = '/file' + e.resultPictureFileUrl
      })
      this.tableData = sortRecords(res?.data || [])
    },

    async getSchemeOptions() {
      const res = await this.$service.get('/moreDesignOptions/queryList', {})
      return sortRecords(res?.data || [])
    },

    // openModal
    openModal(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.designDetailRef.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/plan-investment-estimate/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTable()
    }
  }
}
</script>

<style scoped>
.scheme-investment-estimate {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
</style>
